import { Link } from "react-router-dom";
import { Map } from "lucide-react";

export function AuthLayout({ title, subtitle, children, footer, testId }) {
  return (
    <div className="min-h-[calc(100vh-4rem)] grid lg:grid-cols-[1.1fr_1fr]">
      <div className="hidden lg:flex topo-bg grain relative flex-col justify-between p-12 text-white">
        <Link to="/" className="flex items-center gap-2.5 relative z-10">
          <span className="w-9 h-9 rounded-xl bg-emerald-500 grid place-items-center text-slate-950"><Map size={18} /></span>
          <span className="font-extrabold tracking-tight text-lg">CG Land Geoportal</span>
        </Link>
        <div className="relative z-10 max-w-md">
          <p className="data-label mb-4 text-emerald-400">Chhattisgarh · Cadastral Intelligence</p>
          <h2 className="text-3xl xl:text-4xl font-extrabold tracking-tight leading-tight">Every khasra, every boundary — mapped with precision.</h2>
          <p className="mt-4 text-slate-300">Browse land parcels across Raipur, Bilaspur, Durg, Bastar and more. Premium members unlock the full interactive map layer.</p>
          <div className="mt-8 grid grid-cols-3 gap-4">
            {[["12", "Districts"], ["84+", "Parcels"], ["₹499", "Per month"]].map(([v, l]) => (
              <div key={l} className="rounded-xl border border-white/10 bg-white/5 p-4"><p className="font-mono text-xl font-semibold">{v}</p><p className="text-xs text-slate-400 mt-1">{l}</p></div>
            ))}
          </div>
        </div>
        <p className="relative z-10 text-xs text-slate-500 font-mono">21.2514° N, 81.6296° E · Raipur</p>
      </div>
      <div className="flex items-center justify-center p-6 sm:p-12 grid-bg">
        <div className="w-full max-w-md fade-up" data-testid={testId}>
          <h1 className="text-3xl font-extrabold tracking-tight">{title}</h1>
          {subtitle && <p className="text-muted-foreground mt-2">{subtitle}</p>}
          <div className="mt-8">{children}</div>
          {footer && <div className="mt-6 text-sm text-muted-foreground">{footer}</div>}
        </div>
      </div>
    </div>
  );
}
